import React, { useEffect, useState } from 'react';
import messages from '../../../messages';
import { updateCompany, getSellerData } from '../../API';
import { pathname } from '../../../utils/path/path';
import { useHistory } from 'react-router-dom';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useCompanyContext } from '../../../contexts/Company';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FinishedPreQualify from './FinishedPreQualify';

const useStyles = makeStyles((theme: any) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  button: {
    fontSize: '1.2em',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },

  backButton: { color: 'black' },
  confirmButton: { marginLeft: theme.spacing(2) },
  manuallyEnterButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
}));

export default function VerifySeller({ setVerifySellerName }) {
  const classes = useStyles();
  const history = useHistory();
  const snackbar = useSnackbarContext();
  const { goForward, setLoading } = useOnboardingContext();
  const { business } = useCompanyContext();
  const { trackEvent } = useEventTrackerContext();
  const [finishedPreQualifySteps, setFinishedPreQualifySteps] = useState(false);
  const hasBusinessName = business.name;

  useEffect(() => {
    if (!finishedPreQualifySteps) return;
    setTimeout(async () => {
      goForward();
    }, 5500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finishedPreQualifySteps]);

  async function handleSubmit() {
    try {
      setLoading(true);
      const storeUrl = `https://www.amazon.com/s?me=${business.sellerId}`;
      await updateCompany({
        name: business.name,
        store_url: storeUrl,
      });
      getSellerData(business.sellerId, true).catch((error) => {
        console.log('Error getting seller data.');
      });
      trackEvent({ event: 'entered_seller_id', seller_id: business.sellerId });
      trackEvent({ event: 'entered_store_url', store_url: storeUrl });
      setFinishedPreQualifySteps(true);
    } catch (error) {
      snackbar.show(messages.onboarding.sellerName.saveErr, 'error');
    }
    setLoading(false);
  }

  return finishedPreQualifySteps ? (
    <FinishedPreQualify />
  ) : (
    <>
      {!hasBusinessName && (
        <React.Fragment>
          <Typography variant="h6" component="h6" align="center">
            {business.sellerId}
          </Typography>
          <div className={classes.buttons}>
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={() => setVerifySellerName(false)}
            >
              Let me try another Seller ID
            </Button>
          </div>
        </React.Fragment>
      )}
      {hasBusinessName && (
        <React.Fragment>
          <div className={classes.buttons}>
            <Button
              className={classes.button + ' ' + classes.backButton}
              onClick={() => setVerifySellerName(false)}
            >
              No, let me try another Seller ID
            </Button>
            <Button
              className={classes.button + ' ' + classes.confirmButton}
              color="primary"
              variant="contained"
              onClick={handleSubmit}
            >
              Yes, that's my store
            </Button>
          </div>
        </React.Fragment>
      )}
      <div className={classes.manuallyEnterButtonContainer}>
        <Button
          className={classes.button}
          onClick={() => history.push(pathname.onboarding.extras.storeUrl.url)}
        >
          Manually enter store URL
        </Button>
      </div>
    </>
  );
}
